import { render, staticRenderFns } from "./NMenuItem.vue?vue&type=template&id=835c1ace"
import script from "./NMenuItem.vue?vue&type=script&lang=js"
export * from "./NMenuItem.vue?vue&type=script&lang=js"
import style0 from "./NMenuItem.vue?vue&type=style&index=0&id=835c1ace&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports